import React, { useEffect } from 'react'
import { observer } from 'mobx-react'
import { Icon } from 'components'
import { deliveryMobx, checkoutMobx, memberMobx } from '@mobxStore'
import { cartMobx } from 'restaurant'
import { SelectAddressModal } from '@cps'
import { modalLayer, useHistoryNew } from '@utils'
import deliveryController from '@ctrls/deliveryController'
import { TEEatType } from 'restaurant/mobx/store.mobx'
import './index.scss'

export interface ICheckoutAddressProps {
}

const CheckoutAddress: React.FC<ICheckoutAddressProps> = (props) => {
  const { address, viewAddresses } = deliveryMobx
  const { contactError } = checkoutMobx

  const showEditAddress = async () => {
    if (!deliveryMobx.hasAddresses) await memberMobx.getMemberAddress()
    if (!deliveryMobx.hasAddresses) {
      // deliveryController.editAddressModal({
      //   eatType: TEEatType.delivery,
      //   callback (store) {
      //   }
      // })
    } else {
      deliveryMobx.availableAddress && deliveryMobx.setAddress(deliveryMobx.availableAddress)
    }
  }

  const handleClick = () => {
    if (viewAddresses?.length) {
      modalLayer(SelectAddressModal, {
        eatType: TEEatType.delivery,
      }, 'SelectAddressModal').then(() => {
      }, () => { })
    } else {
      deliveryController.editAddressModal({
        eatType: TEEatType.delivery,
        callback (store) {
        }
      })
    }
  }

  useEffect(() => {
    if (deliveryMobx.isDelivery) {
      if (!cartMobx.info?.contactInfo?.shortAddress || !deliveryMobx.address || !deliveryMobx.address?.inArea || !deliveryMobx.address?.inCityId) {
        showEditAddress()
      }
    }
  }, [deliveryMobx.isDelivery])

  return (
    <div className='checkout-address-wrapper' data-cypid='checkoutAddress' onClick={handleClick}>
      {/* <Icon name={bo === 'cn' ? 'delivery-cn' : 'delivery-us'} /> */}
      {
        address && cartMobx.info?.contactInfo?.shortAddress ? (
          <div className='checkout-address-info'>
            <div className='contact-address'>{cartMobx.info?.contactInfo?.shortAddress}</div>
            <div className='contact-way'>{cartMobx.info.contactName} {cartMobx.info.contactMobile}</div>
          </div>
        ) : <div className={`checkout-address-info${contactError.addressError && !cartMobx.info?.contactInfo?.address ? ' error' : ''}`}>{i18n.t(!viewAddresses?.length ? 'newCart.addAddressTip' : 'newCart.selectAddress')}</div>
      }
      <Icon name='chevron-right' />
    </div>
  )
}

export default observer(CheckoutAddress)
